// SpinnerLoader.jsx
import React from "react";
import { CircularProgress, Box } from "@mui/material";

const SpinnerLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100px",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default SpinnerLoader;
